import { CaseNumberTool } from '@/components/CaseNumberTool';
import { Disclosure } from '@/components/Disclosure';
import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { ja } from '@/i18n/ja';

/**
 * 構造化データ。
 * ユーザーの入力や変換結果は URL・metadata・structured data に一切含めない。
 */
const structuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebApplication',
      name: ja.hero.h1,
      description: ja.meta.description,
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'Web',
      inLanguage: 'ja',
      isAccessibleForFree: true,
      offers: { '@type': 'Offer', price: '0', priceCurrency: 'JPY' },
      publisher: { '@type': 'Organization', name: 'Lawsnote' },
    },
    {
      '@type': 'FAQPage',
      mainEntity: ja.faq.items.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: { '@type': 'Answer', text: item.a },
      })),
    },
  ],
};

export function FormattingPage() {
  return (
    <>
      <Header />

      <main>
        <div className="ln-hero-gradient border-b border-line">
          <div className="mx-auto max-w-content px-5 pb-7 pt-9">
            <h1 className="text-[26px] font-bold leading-tight tracking-tight text-ink sm:text-[31px]">
              {ja.hero.h1}
            </h1>
            <p className="mt-2.5 text-[16px] leading-relaxed text-ink-muted">{ja.hero.lead}</p>
            <p className="mt-1 text-[14px] leading-relaxed text-ink-subtle">{ja.hero.sub}</p>
          </div>
        </div>

        <div className="mx-auto max-w-content px-5 pb-12 pt-7">
          <CaseNumberTool />

          {/* 常時見せるのは免責の 1 文だけ。詳細はすべて折りたたむ。 */}
          <p className="mt-16 text-[13px] leading-relaxed text-ink-subtle">{ja.disclaimer}</p>

          <div className="mt-4 border-t border-line">
            <Disclosure summary={ja.formats.heading}>
              <div className="overflow-x-auto rounded-ln border border-line">
                <table className="w-full min-w-[28rem] border-collapse text-[13px]">
                  <caption className="sr-only">入力表記と変換後の表記の対応</caption>
                  <thead>
                    <tr className="bg-surface-muted text-left">
                      <th scope="col" className="border-b border-line px-3 py-2 font-bold text-ink">
                        入力例
                      </th>
                      <th scope="col" className="border-b border-line px-3 py-2 font-bold text-ink">
                        変換結果
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {ja.formats.rows.map((row) => (
                      <tr key={row.from}>
                        <td className="border-b border-line px-3 py-2 align-top">{row.from}</td>
                        <td className="border-b border-line px-3 py-2 align-top font-bold text-ink">
                          {row.to}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Disclosure>

            <Disclosure summary={ja.about.heading}>
              <p>{ja.about.body}</p>
            </Disclosure>

            <Disclosure id="input-handling" summary={ja.security.heading}>
              <div className="flex flex-col gap-2">
                {ja.security.points.map((point) => (
                  <p key={point}>{point}</p>
                ))}
              </div>
            </Disclosure>

            <Disclosure summary={ja.faq.heading}>
              <dl className="flex flex-col gap-4">
                {ja.faq.items.map((item) => (
                  <div key={item.q}>
                    <dt className="font-bold text-ink">{item.q}</dt>
                    <dd className="mt-0.5">{item.a}</dd>
                  </div>
                ))}
              </dl>
            </Disclosure>
          </div>
        </div>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        // biome-ignore lint/security/noDangerouslySetInnerHtml: JSON-LD from a static, code-defined object -- no user input reaches this.
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
    </>
  );
}
